import { MAILTO, TEL, RELATION } from '../../constants';

const checkIsWhiteListedDomain = hostname => {
  const whitlistedDomainsString = process.env.BLAZE_RELATED_DOMAINS || '';
  const whitelistedDomains = whitlistedDomainsString.split(',');
  return !!whitelistedDomains.find(domain => hostname.indexOf(domain) !== -1);
};

const hasRelationship = (sanitizedUrl, isSameDomain) => {
  const hasRelation =
    !sanitizedUrl ||
    sanitizedUrl.includes(MAILTO) ||
    sanitizedUrl.includes(TEL) ||
    isSameDomain ||
    checkIsWhiteListedDomain(sanitizedUrl);

  return hasRelation ? undefined : RELATION;
};

export default hasRelationship;
